import {ReportData} from "../../../reports/report.data";
import {collection, field} from "@fedeltapointofsale/data-client";
import {InventoryReportSelectionData} from "../../inventory/controls/inventory-report-selection-control.component";

export class StockUsageReportData extends ReportData<StockUsageReportData> {
    @field exclusive: boolean = true;

    @collection(InventoryReportSelectionData) inventories: InventoryReportSelectionData[];
}
